
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserRewardsHistoryEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserRewardsHistoryEntry"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"credit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gems_amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":113}};
    doc.loc.source = {"body":"fragment UserRewardsHistoryEntry on UserRewardsHistoryEntry {\n  id\n  description\n  credit\n  gems_amount\n  date\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
